export default __webpack_public_path__ + "static/SaolText-Regular-06487a4346dd9dea9c6e45104e1d2040.woff";